import { AxiosResponse } from 'axios';
import client from './clientRetryable';
import getAuthHeader from '@/util/getAuthHeader';

export default {
  async fetchAgreements(applicantId: number): Promise<AxiosResponse<Response>> {
    const response: AxiosResponse<Response> = await client.post<Response>(
      `applicants/${applicantId}/agreements`,
      null,
      { headers: getAuthHeader() }
    );
    return response;
  },

  async fetchAgreementsAgreed(applicantId: number, request: Request): Promise<AxiosResponse<void>> {
    const response: AxiosResponse<void> = await client.put<void>(
      `applicants/${applicantId}/agreements/agreed`,
      request,
      { headers: getAuthHeader() }
    );
    return response;
  }
};

export interface Response {
  termsOfServiceVersion: number;
  privacyPolicyVersion: number;
}

export interface Request {
  termsOfServiceVersion: number;
  privacyPolicyVersion: number;
}
